<template>
  <div class="dialog-container">
    <div class="dialog" :style="{width:width}">
      <div class="title">{{ title }}</div>
      <div class="body">
        <slot />
      </div>
      <div class="btn-box">
        <div class="cancle" @click="cancel">{{ cancelText }}</div>
        <div class="confirm" @click="submit">{{ submitText }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from "@/utils/i18n";
export default {
  props: {
    title: {
      type: String,
    },
    width:{
      default: '30%'
    },
    submitText: {
      type: String,
      default: i18n.t("確認"),
    },
    cancelText: {
      type: String,
      default: i18n.t("取消"),
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel(e) {
      this.$emit("cancel", e);
    },
    submit(e) {
      this.$emit("submit", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-container {
  width: 100vw;
  height: 100vh;
  background-color: #000000ad;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .dialog {
    background-color: #fff;
    border-radius: 4px;
    font-size: 36px;
    color: #595959;
    // max-width: 391px;
    width: calc(90vw - 66px);
    margin: auto;
    padding: 33px;
    @media only screen and (max-width: 900px) {
      padding: 33px;
      border-radius: 4px;
      font-size: 36px;
      width: calc(90vw - 66px);
      max-width: none;
    }
    .title {
      text-align: center;
    }
    .body {
      min-height: 100px;
      font-size: 16px;
      font-weight: 300;
      color: #999;
      line-height: 22px;
      margin: 13px;
      @media only screen and (max-width: 900px) {
        font-size: 16px;
        line-height: 1;
        min-height: 250px;
      }
    }
    .btn-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      color: #fff;
      @media only screen and (max-width: 900px) {
        font-size: 18px;
      }
      .cancle {
        width: 180px;
        line-height: 40px;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        height: 40px;
        background-color: #dcdcdc;
        @media only screen and (max-width: 900px) {
          font-size: 14px;
          width: 120px;
          line-height: 40px;
          height: 40px;
        border-radius: 4px;
        }
      }
      .confirm {
        width: 180px;
        line-height: 40px;
        height: 40px;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        background-color: #c6a86c;
        @media only screen and (max-width: 900px) {
          font-size: 14px;
          width: 120px;
          line-height: 40px;
          height: 40px;
        border-radius: 4px;
        }
      }
    }
  }
}
</style>
